import React from 'react';

import { StandardButton } from 'components/ui/Button';
import { getStaticMediaUrl} from 'utils/Urls';
import Export from './../../../assets/icon--export-white.svg';

const DownloadCSVButton = ({ link, selectedStatus }: { link: string; selectedStatus: any }) => {
  return (
    <a href={`${window.location.origin}/v2/api/${link}?status=${selectedStatus}`} target='_self'>
      <StandardButton className="mr-6" type="button">
        <div className="flex justify-center items-center">
          <img className="pl-10" width="45" src={getStaticMediaUrl(Export)} alt="" />
          <span className="pl-4 pr-10 capitalize font-bold text-white">Download CSV</span>
        </div>
      </StandardButton>
    </a>
  );
};

export default DownloadCSVButton;
